import React from "react";


const Error = () =>{
   
    return(
      <section className="header-breadcrumb ">
      <h1>Error</h1>
      </section>
    )
  }
  
  export default Error;